import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Chapter, Reveal } from "./shared";
import { useSiteConfig } from "@/context/SiteConfigContext";

const FAQS = [
  { q: "Quanto custa uma visita técnica?", a: "O valor da visita técnica depende da região e do tipo de serviço. Entre em contato pelo WhatsApp e informamos o valor exato antes de qualquer deslocamento — sem surpresas." },
  { q: "Quanto tempo leva o atendimento?", a: "Emergências são priorizadas e atendidas no menor tempo possível. Serviços agendados geralmente são realizados no mesmo dia ou no dia seguinte." },
  { q: "Vocês atendem aos finais de semana?", a: "Sim! Atendemos de segunda a sábado, e emergências com vazamento de gás são atendidas 24 horas, todos os dias." },
  { q: "Emitem nota fiscal?", a: "Sim, emitimos nota fiscal de todos os serviços realizados, para pessoas físicas e jurídicas." },
  { q: "Vocês atendem condomínios e empresas?", a: "Sim, atendemos residências, condomínios, restaurantes e indústrias, com contratos de manutenção preventiva personalizados." },
  { q: "Vocês fazem conversão de fogão?", a: "Sim, convertemos fogões e cooktops de gás GLP para gás natural (GN) e vice-versa, com teste de vazamento incluso." },
  { q: "Instalam aquecedor a gás?", a: "Sim, instalamos aquecedores de passagem e de acumulação, seguindo todas as normas de segurança e exigências do fabricante." },
  { q: "O teste de estanqueidade é obrigatório?", a: "Ele é exigido pela NBR 15526 em novas instalações e é altamente recomendado periodicamente para garantir que não há vazamentos na tubulação." },
  { q: "Quanto tempo dura a garantia do serviço?", a: "Todos os nossos serviços possuem garantia de 90 dias a 1 ano, dependendo do tipo de serviço executado." },
  { q: "Quais formas de pagamento aceitam?", a: "Aceitamos PIX, dinheiro, cartão de crédito e débito. Para empresas e condomínios, trabalhamos também com faturamento." },
];

export const Faq = () => {
  const cfg = useSiteConfig();
  const faqs = cfg.faqs?.length ? cfg.faqs : FAQS;

  return (
  <section className="bg-zinc-50 py-24 sm:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-6xl px-5 lg:px-8">
      <Chapter num="08 — Dúvidas" title="Perguntas" accent="Frequentes" />
      <Reveal>
        <Accordion type="single" collapsible className="grid gap-4 md:grid-cols-2">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-zinc-200 bg-white px-6 data-[state=open]:border-[var(--primary)]"
            >
              <AccordionTrigger className="py-5 text-left font-display text-base font-semibold uppercase tracking-wide text-zinc-900 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-zinc-500">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
  );
};
